import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { api } from "../utils/helpers";

const EMPTY_ARTIFACTS = [];

// One inventory request serves every package in the current instance.
export default function useContentRuntime(instanceId, enabled) {
  const [state, setState] = useState({ instanceId: null, status: "idle", artifacts: [] });
  const [revision, setRevision] = useState(0);
  const manualRefresh = useRef(null);
  const refresh = useCallback(() => {
    manualRefresh.current = instanceId;
    setRevision(value => value + 1);
  }, [instanceId]);
  useEffect(() => {
    if (!instanceId || !enabled) return undefined;
    const controller = new AbortController();
    let active = true;
    const force = manualRefresh.current === instanceId;
    manualRefresh.current = null;
    setState({ instanceId, status: "loading", artifacts: [] });
    api(`/api/${encodeURIComponent(instanceId)}/content/runtime-artifacts${force ? "?force=true" : ""}`, { signal: controller.signal })
      .then(response => {
        if (response?.complete !== true || !Array.isArray(response.artifacts)) throw new Error("Incomplete runtime inventory");
        if (active) setState({ instanceId, status: "ready", artifacts: response.artifacts });
      }).catch(() => {
        if (active) setState({ instanceId, status: "error", artifacts: [] });
      });
    return () => { active = false; controller.abort(); };
  }, [instanceId, enabled, revision]);
  const current = state.instanceId === instanceId ? state : { status: enabled ? "loading" : "idle", artifacts: EMPTY_ARTIFACTS };
  const byId = useMemo(() => new Map(current.artifacts.map(artifact => [artifact.Id, artifact])), [current.artifacts]);
  return { status: current.status, byId, refresh };
}
